export const SET_SEARCH_HOTEL_CONDITION_VALUES =
  "SET_SEARCH_HOTEL_CONDITION_VALUES";
export const SET_SEARCH_HOTEL_ADVANCED_CONDITION_VALUES =
  "SET_SEARCH_HOTEL_ADVANCED_CONDITION_VALUES";
export const SET_SEARCH_HOTEL_SORT_CONDITION_VALUES =
  "SET_SEARCH_HOTEL_SORT_CONDITION_VALUES";
